import React from "react";
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Cell,} from "recharts";
import "./ChartsItem.scss";
import TitleChart from "./TitleChart";

const ChartItem = ({data, colors, title, isShow, width, height}) => {

  try {
    return (
      <div className="chart__monitoring__box">
        <TitleChart title={title} isShow={isShow}/>
        <div
          className="chart___monitoring__Bar"
          style={{height: `${height}`, width: `99%`}}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              barCategoryGap="10%"
              margin={{top: 10, right: 5, left: 10, bottom: 40}}
              barGap="15px">
              <CartesianGrid vertical={false} strokeDasharray="0"/>
              <XAxis
                tick={{fontSize: 12, fontFamily: "IRANSans-Bold", dy: 15}}
                interval={0}
                angle={-30}
                dataKey="name"
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{fontSize: 12, fontFamily: "IRANSans-Bold"}}
                dx={-40}
                domain={[0, 100]}
                tickCount={3}
                axisLine={false}
                tickLine={false}
              />
              <Bar dataKey="uv" barSize={3.5}>
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={colors[index % colors.length]}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ChartItem;
